<template>
    <div>
        <Row style="margin-bottom:20px;">
            <div :style="floatDom">
                <slot name="actions"></slot>
            </div>
        </Row>

        <Form v-if="modalWrap" ref="search" :model="model" :inline="true" :label-width="120" @submit.native.prevent="submitForm">
            <Row>
                <slot v-if="modalWrap">此处为查询条件</slot>
                <div style="float:right">
                    <Button type="primary" v-if="showQueryBtn" html-type="submit">查询</Button>
                    <Button type="default" v-if="showReseBtn" @click="resetSearchForm">清空</Button>
                </div>
            </Row>
        </Form>
        <Row>
            <div style="">
                <slot name="bottomActions"></slot>
            </div>
        </Row>
        <PagedList ref='PagedList' :pageFloat='pageFloat' :pageSize='pageSize' :stripe='stripe' :loading="loading" :page="page" :columns="columns" :highlight='highlight' :showHeader='showHeader' :pageList="pageList" :list="newList" :total="total" @changePage="changePage" @changeSelection="onChangeSelection" @clickRow='onclickRow' @onSortCange='onSortCange'>
            <div slot='footerData'>
                <slot name="bottomFooter"></slot>
            </div>
        </PagedList>
    </div>
</template>

<script>
    import qs from 'qs'
    import Vue from 'vue'
    import PagedList from "./PagedList";
    import util from '@/libs/util.js'

    /**
     * 识别并转换字符串的实际类型
     * 1. 尝试识别true/false
     * 2. 尝试识别日期字符串
     * 3. 尝试识别数字：float/int
     * 4. 其他类型原样返回
     * @param value
     * @returns {*}
     */
    function castToTypedValue(value,key) {
        if ((typeof value) !== 'string' || !value.length) {
            return value;
        }
        //for boolean
        if (value === 'true' || value === 'false') {
            return value === 'true';
        }

        if (isNaN(value)) {
            //for Date
            // let date = Date.parse(value);
            // if (isNaN(date)) {
            //     return value;
            // } else {
            //     // return new Date(date);
            // }
                return value;
        } else {
            //for Number:float or int
            if( key == 'expiredDays') {
                return value
            } else {
                if (value.indexOf('.') === -1) {
                    if( value.length < 16 && value != ' ' && !(/^0/.test(value))) {
                    return Number.parseInt(value); 
                    } else {
                        return value
                    }
                } else {
                    if( value.length < 16 && value != ' ' && !(/^0(?!\.)/.test(value))) {
                    return Number.parseFloat(value);
                    } else {
                        return value
                    }
                }
            }
        }
    }

    /**
     * 从查询字符串中提取出强类型参数（query中的参数都是string类型）
     * @param query
     * @returns {*}
     */
    function parseParamsFromQuery(query) {
        if (!query) return query;
        let params = {};
        Object.getOwnPropertyNames(query)
            .forEach(prop => {
                let value = query[prop];
                params[prop] = castToTypedValue(value,prop);
            });
        return params;
    }

    /**
     * 过滤指定source对象的所有字段，符合过滤条件的字段将包含在返回的目标对象中
     * @param source
     * @param filter
     * @returns {*}
     */
    function filterProps(source, filter) {
        if (!source) return source;

        let target = {};
        Object.getOwnPropertyNames(source)
            .filter(filter)
            .filter(prop => prop !== '__ob__')
            .forEach(prop => {
                target[prop] = source[prop];
            });
        return target;
    }

    function restorePage(target, source) {
        Object.assign(target, filterProps(source, prop => ['page', 'size'].indexOf(prop) !== -1));
    }

    function restoreModel(target, source) {
        let temp = filterProps(source, prop =>
            ['page', 'size'].indexOf(prop) === -1
        );
        Object.assign(target, temp);
        let targetProps = Object.getOwnPropertyNames(temp);
        Object.getOwnPropertyNames(target).forEach(prop => {
            if (targetProps.indexOf(prop) === -1 && prop !== '__ob__') {
                target[prop] = undefined;
            }
        });
    }


    export default {
        name: "UserManager",
        props: {
            //搜索接口URL
            api: {
                type: String,
                required: true,
            },
            //分页是否显示
            pageList: {
                type: Boolean,
                default: true
            },
            //查询参数对象
            model: {
                type: Object,
                required: true
            },
            //查询区域是否显示
            modalWrap: {
                type: Boolean,
                default: true
            },
            //表格schema定义
            columns: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            //指定查询参数是否与路由中的参数字符串绑定
            bindWithRoute: {
                type: Boolean,
                default: true
            },
            // 查询按钮是否显示
            showQueryBtn: {
                default: true,
                type: Boolean,
            },
            // 清空按钮是否显示
            showReseBtn: {
                default: true,
                type: Boolean,
            },
            // 单选是否高亮
            highlight: {
                default: false,
                type: Boolean,
            },
            // 是否显示表头
            showHeader: {
                default: true,
                type: Boolean,
            },
            // 是否斑马纹
            stripe: {
                default: true,
                type: Boolean,
            },
            floatDom: {
                type: String,
                default: 'float:right',
            },
            // 请求结果处理函数
            responseFn: {
                type: Function
            },
            pageFloat: {
               type: String,
               default: 'float: right;' 
            },
            pageSize: {
                type: Array,
                default: function() {
                    return [10, 20, 50,100,400]
                }
            },
            page: {
                type: Object,
                default: function () {
                    return {
                        page: 1,
                        size: 10
                    };
                }
            }
        },
        data: function () {
            return {
                total: 0,
                list: [],
                loading: true,
                // page: {
                //     page: 1,
                //     size: this.size
                // },
                originModel: null,
            };
        },
        created() {
      
            this.originModel = Object.assign({}, this.model);
            if (this.bindWithRoute) {
                let query = this.$route.query;
                let params = parseParamsFromQuery(query);
                if (params.size) this.page.size = params.size
            }
        },
        mounted () {
            this.forceReload();
        },
        watch: {
            $route: function () {
                this.forceReload();
            }
        },
        methods: {
            /**
             * 刷新数据
             */
            forceReload() {
                if (this.bindWithRoute) {
                    let query = this.$route.query;
                    if (Object.getOwnPropertyNames(query).length) {
                        let params = parseParamsFromQuery(query);
                        restorePage(this.page, params);
                        restoreModel(this.model, params);
                        this.fetchData(params);
                    } else {
                        //无查询参数时
                        restoreModel(this.model, this.originModel);
                        Object.assign(this.page, {page: 1, size: this.page.size});
                        this.fetchData(Object.assign({}, this.page, this.model));
                    }
                } else {
                    let params = Object.assign(
                        {page: 1, size: this.page.size}, this.page, this.model
                    );
                    this.fetchData(params);
                }
            },

            /**
             * 翻页事件
             */
            changePage(page,prod) {
                if (prod == "newSize") page.page = 1
                Object.assign(this.page, page);
                this.submitSearchParams();
            },
            /**
             * 翻页事件
             */
            onChangeSelection(selection){
                // this.$emit('changeSelection',selection);
                this.$emit('changeSelection', selection, this.list)
            },
            /**
             * 单选事件
             */
            onclickRow(selection){
                // this.$emit('changeSelection',selection);
                this.$emit('clickRow', selection, this.list)
            },
            onSortCange (row) {
                this.$emit('onSortCange', row)
            },
            /**
             * 提交表单
             */
            submitForm(reset) {
                Object.assign(this.page, {page: 1});
                this.submitSearchParams(reset);
            },
            /**
             * 提交查询参数事件
             */
            submitSearchParams(reset) {
                let params = Object.assign(
                    {}, this.model, this.page
                );
                if (reset && params.nameOrNum != undefined) {
                    params.nameOrNum = ''
                }
                if (params.settlementPeriod != undefined && params.settlementPeriod) {
                    params.settlementPeriod = util.formatTimestamp(this.model.settlementPeriod,"yyyy-MM")
                }
                if (this.bindWithRoute) {
                    this.$router.push({
                        query: params
                    });
                } else {
                    this.fetchData(params);
                }
            },
            /**
             * 清空表单事件
             */
            resetSearchForm() {
                this.$refs.search.resetFields();
                Object.assign(this.page, {page: 1});
                this.$emit('reset')
                Vue.nextTick(() => {
                    this.submitSearchParams('reset');
                });
            },
            /**
             * 刷新数据
             */
            fetchData(params) {
                this.loading = true;
                this.$http
                    .get(`${this.api}?` + qs.stringify(params))
                    .then(result => {
                        this.loading = false;
                        this.list = result.list;
                        this.$emit('submitInquire',result)
                        this.total = result.totalElements;
                    })
                    .catch(error => {
                        this.list = [];
                        this.loading = false;
                        this.$Message.error("错误：" + error.message);
                    });
            },
            exportExcel (columns) {
                this.$refs.PagedList.$refs.table.exportCsv({
                    filename: '配方列表',
                    original:false,
                    columns: columns,
                    data: this.list.map(k => {
                        k.code = '\t' + k.code;
                        return k;
                    })
                })
            }
        },
        computed: {
          newList () {
            let ret = this.list
            if (this.responseFn) ret = this.responseFn(ret, this.total)
            return ret
          }
        },
        components: {
            PagedList
        }
    };
</script>




// WEBPACK FOOTER //
// SearchList.vue?00ffcc71